import { useState, useEffect } from 'react';

export function useClasses(...classNames) {
  const [classes, set] = useState(classNames.filter((className) => !!className).join(' '));

  useEffect(() => {
    set(classNames.filter((className) => !!className).join(' '));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(classNames)]);

  return classes;
}

function from(flags) {
  return (flag) => {
    return flags[flag];
  };
}

export const flags = { from };
